<ng-container
    *ngIf="state$ | async as state"
>
    <app-trial-banner
        *ngIf="state.hasManageBillingPermission && state.billingDetails.inService"
        [billingDetails]="state.billingDetails"
        (upgradeTrialClicked)="upgradeTrialClicked()"
    >
    </app-trial-banner>

    <div
        *ngIf="!state.billingDetails.inService"
        class="subscription-paused-overlay d-print-none"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="subscriptionPausedTitle"
        aria-describedby="subscriptionPausedDescription"
    >
        <div class="subscription-paused-panel">
            <div class="subscription-paused-icon">
                <i class="bi bi-pause-circle"></i>
            </div>
            <h2 id="subscriptionPausedTitle">
                Service paused
            </h2>
            <p
                id="subscriptionPausedDescription"
                class="text-body-secondary mb-0"
            >
                Your TableSense subscription is not currently in service, so customers can no longer make bookings until billing is resumed.
            </p>
            <div
                *ngIf="state.hasManageBillingPermission"
                class="vstack gap-2 align-items-center"
            >
                <button
                    type="button"
                    class="btn btn-primary"
                    [disabled]="checkoutUrlLoading || checkoutUrl === null"
                    (click)="checkoutClicked()"
                >
                    <span
                        *ngIf="checkoutUrlLoading"
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                    ></span>
                    {{ checkoutUrlLoading ? 'Preparing checkout' : 'Resume subscription' }}
                </button>
                <button
                    *ngIf="checkoutUrlError"
                    type="button"
                    class="btn btn-link"
                    (click)="retryCheckoutUrlPreload(state)"
                >
                    Try preparing checkout again
                </button>
            </div>
            <p
                *ngIf="!state.hasManageBillingPermission"
                class="text-body-secondary mb-0"
            >
                Ask an account owner to resume the subscription.
            </p>
        </div>
    </div>
</ng-container>
